<app-green-banner
  [title]="'i18n.productDetail.title'"
  [platform]="platformType"
  [isInModal]="true"
  (closeEmitter)="dismissModal()"
></app-green-banner>

<ion-content
  *ngIf="product$ | async as product"
  data-cy="product-detail-modal-content"
  class="product-detail-content"
>
  <ion-grid [fixed]="true" class="product-detail-grid">
    <ng-container *ngIf="product && !product.notFound; else notFound">
      <section class="product-detail-section">
        <app-product-detail-toast
          *ngIf="!!toast"
          [toast]="toast"
        ></app-product-detail-toast>
        <app-product-detail-summary
          [product]="product"
          [sellerPriceDetail]="sellerPriceDetails$ | async"
          [orderItem]="orderItem$ | async"
          [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
          [isInventory]="true"
          [newSearchEnabled]="newSearchEnabled$ | async"
          (tabSelectionEmitter)="onTabSelection($event)"
          (quantityUpdateEmitter)="onQuantityUpdate($event)"
          (shareButtonPressEmitter)="onShareButtonPress()"
        ></app-product-detail-summary>
        <section *ngIf="product.alternative" class="product-detail-alt-section">
          <app-product-alternative
            *ngIf="
              product.alternative.required && product.alternative.available
            "
            [productAlternative]="product.alternative"
            [originalProduct]="product"
            [selectedProductNumber]="selectedProductNumber"
            [orderItem]="alternativeOrderItem$ | async"
            [pricingDisabled]="
              product.selectedCustomer?.ogPrintPriceInd === 'N'
            "
            (quantityUpdateEmitter)="onQuantityUpdate($event)"
          ></app-product-alternative>
        </section>
        <ng-container *ngIf="isSellerCustomer">
          <app-seller-detail-description
            [sellerPriceDetail]="sellerPriceDetails$ | async"
            [isPmeSgpEnabled]="isPmeSgpEnabled$ | async"
            [product]="product"
          ></app-seller-detail-description>
          <app-seller-detail-more-information
            [product]="product"
            [currentProductNumber]="selectedProductNumber"
            [sellerPriceDetails]="sellerPriceDetails$ | async"
          ></app-seller-detail-more-information>
        </ng-container>
        <app-product-detail-description
          *ngIf="!isSellerCustomer"
          [product]="product"
        ></app-product-detail-description>
      </section>

      <section class="product-detail-section">
        <ng-container *ngIf="!isSellerCustomer">
          <app-product-detail-additional-info
            [product]="product"
          ></app-product-detail-additional-info>
          <app-product-detail-shipping-info
            [product]="product"
          ></app-product-detail-shipping-info>
        </ng-container>
        <app-product-detail-downloads
          *ngIf="product.summary?.productAssets?.documents"
          [rawDocuments]="product.summary?.productAssets?.documents"
        ></app-product-detail-downloads>
      </section>
      <ng-container *appShowSplit="[productQuestionsFeatureFlag]">
        <section
          *ngIf="!isSellerCustomer && product.summary?.isExclusiveBrand"
          class="product-detail-section"
        >
          <app-pwr-product-details-questions
            [productNumber]="selectedProductNumber"
            [emptyState]="noQuestions"
          ></app-pwr-product-details-questions>
        </section>
      </ng-container>
      <ng-container *appShowSplit="[productReviewsFeatureFlag]">
        <section *ngIf="!isSellerCustomer" class="product-detail-section">
          <app-power-reviews-details
            [productNumber]="selectedProductNumber"
          ></app-power-reviews-details>
        </section>
      </ng-container>
    </ng-container>
    <ng-template #notFound>
      <section class="product-not-found">
        <h4 data-cy="product-detail-not-found-text">
          {{ 'i18n.productDetail.notFound' | translate }}
        </h4>
      </section>
    </ng-template>
  </ion-grid>
</ion-content>

<div class="go-top-section">
  <ion-button
    class="usf-fill-green-button"
    data-cy="go-to-top-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}
    <ion-icon
      name="chevron-up-circle-outline"
      data-cy="go-to-top-button-icon"
    ></ion-icon>
  </ion-button>
</div>

<!-- Floating Tooltip for PDP -->
<div class="help-icon">
  <img
    data-cy="pdp-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>
